
import { styled } from '@mui/material/styles';
import { Box, Table, TableCell, TableContainer, TableHead, TableRow, Typography, Button } from '@mui/material';

export const MainContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(3),
  backgroundColor: '#fff',
  borderRadius: '8px',
  boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.05)',
  padding: theme.spacing(3),
  width: '100%',
}));

export const HeaderContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: theme.spacing(3),
}));

export const PageTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  fontSize: '1.25rem',
  color: '#333',
}));

export const CreateButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  borderRadius: '6px',
  backgroundColor: '#5E8E7E',
  color: '#fff',
  fontWeight: 600,
  padding: '8px 24px',
  '&:hover': {
    backgroundColor: '#4A7A6A',
  }
}));

export const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  borderRadius: '8px',
  border: '1px solid #E0E0E0',
}));

export const StyledTable = styled(Table)(({ theme }) => ({
  minWidth: 650,
}));

export const StyledTableHead = styled(TableHead)(({ theme }) => ({
  '& th': {
    backgroundColor: '#5E8E7E',
    color: '#fff',
    fontWeight: 600,
    fontSize: '0.875rem',
  }
}));

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(even)': {
    backgroundColor: '#FAFAFA',
  },
  '&:hover': {
    backgroundColor: '#F5F5F5',
  },
}));

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  fontSize: '0.875rem',
  padding: '16px 16px',
  color: '#333',
}));

export const ActionButton = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  cursor: 'pointer',
  color: '#1976D2'
}));

export const DeleteIconWrapper = styled(Box)(({ theme }) => ({
  cursor: 'pointer',
  color: '#D32F2F'
}));
